import {
  CommissionTypes,
  hasSingleCommissionRate,
  type CommissionSettings,
} from '@fluenceur/types';

type Translate = (key: string, values?: Record<string, unknown>) => string;

export function getFirstOrderCommission(settings?: CommissionSettings | null) {
  const firstOrder = settings?.firstOrderCommission;
  if (
    !hasSingleCommissionRate(settings) ||
    !firstOrder?.enabled ||
    !firstOrder.type ||
    firstOrder.value == null ||
    firstOrder.value <= 0
  ) {
    return null;
  }
  return {
    type: firstOrder.type,
    value: firstOrder.value,
    trigger: firstOrder.trigger ?? 'affiliate_first_order',
  };
}

export function formatCommissionRate(
  rate: { type: CommissionTypes; value: number },
  locale: string,
  currency: string
) {
  return rate.type === CommissionTypes.Percentage
    ? new Intl.NumberFormat(locale, {
        style: 'percent',
        maximumFractionDigits: 2,
      }).format(rate.value / 100)
    : new Intl.NumberFormat(locale, {
        style: 'currency',
        currency,
        maximumFractionDigits: 2,
      }).format(rate.value);
}

export function formatFirstOrderCommissionSummary(
  settings: CommissionSettings | null | undefined,
  { locale, currency, t }: { locale: string; currency: string; t: Translate }
) {
  const firstOrder = getFirstOrderCommission(settings);
  if (!firstOrder || !hasSingleCommissionRate(settings)) return null;
  return t(
    firstOrder.trigger === 'customer_first_order'
      ? 'programs.rewards.customerFirstOrderSummary'
      : 'programs.rewards.firstOrderSummary',
    {
      first: formatCommissionRate(firstOrder, locale, currency),
      following: formatCommissionRate(settings, locale, currency),
    }
  );
}
